import './AssignmentList.scss';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowsH,
  faBars,
  faBook,
  faCircleExclamation,
  faCube,
  faCutlery,
  faFlask,
  faSnowflake,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';

// AssignmentList Component
const AssignmentList = ({ assignments }) => {
  if (!assignments || assignments.length == 0) {
    return (
      <div className="no-packages-label-container" data-testid="no-packages-label-container">
        <i className="label-no-packages">No packages are assigned to this trailer.</i>
      </div>
    );
  }
  const groupedAssignments = Object.groupBy(assignments, ({ job }) => job?.jobReference);
  return (
    <div className="assignment_list_container" data-testid="assignment_list_container">
      {Object.keys(groupedAssignments).map(key => {
        const assignments = groupedAssignments[key];

        const quantity = assignments?.map(pkg => pkg.quantity).reduce((a, b) => a + b, 0);
        const type = assignments[0]?.job?.packageType?.description
          ? assignments?.every(
              pkg =>
                pkg.job?.packageType?.description == assignments[0]?.job?.packageType?.description,
            )
            ? assignments[0]?.job?.packageType?.description
            : 'Package'
          : 'Package';

        const shipper = assignments[0]?.job?.shipper
          ? assignments?.every(pkg => pkg.job?.shipper?.name == assignments[0]?.job?.shipper?.name)
            ? assignments[0]?.job?.shipper?.name
            : 'Various'
          : 'Not Specified';

        const weight = assignments?.map(pkg => pkg.grossWeightKg).reduce((a, b) => a + b, 0);
        const cubicMetres = assignments
          .map(pkg => Number(pkg.cubicMetres))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);

        const hazard = assignments[0]?.job?.cargoHazardous;
        const fullLoad = assignments[0]?.job?.fullLoad;
        const doNotStack = assignments[0]?.job?.doNotStack;
        const waste = assignments[0]?.job?.commodityCategory?.waste;
        const foodstuffs = assignments[0]?.job?.commodityCategory?.foodstuffs;
        const temperature = assignments[0]?.job?.temperatureControlled;
        const overlength = assignments[0]?.job?.overlength;
        const customs = assignments[0]?.job?.customsFormalities;
        const mustLoad = assignments[0]?.mustLoad;

        return (
          <div className="assignment_container" key={assignments[0]?.job?.jobReference}>
            <div className="job_reference">{assignments[0]?.job?.jobReference}</div>
            <div className="job_quantity">
              {quantity} {type}(s)
            </div>
            <div className="job_shipper">{shipper}</div>
            <div className="job_weight">{weight} kg</div>
            <div className="job_volume">{cubicMetres} m³</div>
            <div className="job_symbol_row">
              {hazard && (
                <div className="job_symbol hazardous">
                  <FontAwesomeIcon icon={faFlask} data-testid="hazard_icon" />
                </div>
              )}
              {fullLoad && (
                <div className="job_symbol full_load">
                  <FontAwesomeIcon icon={faCube} data-testid="full_load_icon" />
                </div>
              )}
              {doNotStack && (
                <div className="job_symbol do_not_stack">
                  <FontAwesomeIcon icon={faBars} data-testid="do_not_stack_icon" />
                </div>
              )}
              {waste && (
                <div className="job_symbol waste">
                  <FontAwesomeIcon icon={faTrash} data-testid="waste_icon" />
                </div>
              )}
              {foodstuffs && (
                <div className="job_symbol foodstuffs">
                  <FontAwesomeIcon icon={faCutlery} data-testid="foodstuffs_icon" />
                </div>
              )}
              {temperature && (
                <div className="job_symbol temp_control">
                  <FontAwesomeIcon icon={faSnowflake} data-testid="temperature_icon" />
                </div>
              )}
              {overlength && (
                <div className="job_symbol overlength">
                  <FontAwesomeIcon icon={faArrowsH} data-testid="overlength_icon" />
                </div>
              )}
              {customs && (
                <div className="job_symbol customs">
                  <FontAwesomeIcon icon={faBook} data-testid="customs_icon" />
                </div>
              )}
              {mustLoad && (
                <div className="job_symbol must_load">
                  <FontAwesomeIcon icon={faCircleExclamation} data-testid="must_load_icon" />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

AssignmentList.propTypes = {
  assignments: PropTypes.array,
};

export default AssignmentList;
